module.exports = __webpack_public_path__ + "static/media/8OLA31.0c7ab729.jpg";